import { useEffect, useState } from 'react';
import templateRestriction from '../../data/templateRestrictions';
import { Draft } from '../services/Store';
import { Kite, TemplateKey } from '../types';

export default function useDraft() {
    const [draft, setDraft] = useState<Kite>(Draft.get());

    useEffect(() => {
        const subscription = Draft.stateChanged.subscribe(({ draft }) => {
            setDraft({ ...draft });
        });
        return () => subscription.unsubscribe();
    }, [setDraft, Draft]);

    return {
        draft,
        restriction: templateRestriction[draft.template],
        changeTemplate: (templateKey: TemplateKey) =>
            Draft.changeTemplate(templateKey),
        changeName: (name, id) => Draft.changeName(name, id),
        changeNotes: (notes, id) => Draft.changeNotes(notes, id),
        updatePart: (part) => Draft.updatePart(part),
        setVariation: (variation) => Draft.setVariation(variation),
    };
}
